<template>
  <router-view />
  <loading :state="showLoading" />
  <server-error-toast ref="serverErrorToast" />
  <info-toast ref="flashMessageToast" />
</template>

<script>
import {Core as YubinBangoCore} from 'yubinbango-core2'
import Loading from "@/views/atoms/Loading";
import ServerErrorToast from '@/views/molecules/toast/ServerErrorToast'
import InfoToast from '@/views/molecules/toast/InfoToast'

window.YubinBangoCore = YubinBangoCore;
export default {
  components: {
    Loading,
    ServerErrorToast,
    InfoToast,
  },
  computed: {
    showLoading() {
      return this.$store.state.apiLoading;
    },
  },
  methods: {
    failApi(reason) {
      if (!this.$store.state.apiErrorHandled && (reason === undefined || !reason?.handled)) {
        this.$refs.serverErrorToast.show();
        this.$store.commit('clearApiErrorHandleStatus');
      }
    },
    showFlashMessage() {
      const message = this.$store.state.flashMessage;
      if (message !== null) {
        this.$refs.flashMessageToast.show(message);
        this.$store.commit('clearFlashMessage');
      }
    },
  }
}
</script>

<style lang="scss">
@import 'scss/main';
</style>
